import { render } from "./ProductModelSettingsTab.vue?vue&type=template&id=002a46e8&scoped=true"
import script from "./ProductModelSettingsTab.vue?vue&type=script&lang=js"
export * from "./ProductModelSettingsTab.vue?vue&type=script&lang=js"

import "./ProductModelSettingsTab.vue?vue&type=style&index=0&id=002a46e8&lang=scss&scoped=true"

import exportComponent from "/builds/initiative/engineering/man_core/man-intelligence-frontend/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-002a46e8"]])

export default __exports__
import QField from 'quasar/src/components/field/QField.js';
import QChip from 'quasar/src/components/chip/QChip.js';
import QIcon from 'quasar/src/components/icon/QIcon.js';
import qInstall from "../../../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(script, 'components', {QField,QChip,QIcon});
